export const DesignData = [
    {
        title: "Swiss Poster",
        software: "InDesign",
        year: "2023",
        thumbnail: "swissPoster",
        imgs: ["swissPoster"],
        pdf: "swissPosterPDF"
    },
    {
        title: "City Poster",
        software: "InDesign",
        year: "2023",
        thumbnail: "cityPoster",
        imgs: ["cityPoster"],
        pdf: "cityPosterPDF"
    },
    {
        title: "Cookbook",
        software: "InDesign",
        year: "2023",
        thumbnail: "cookbook1",
        imgs: [
            "cookbook1",
            "cookbook2",
            "cookbook3",
            "cookbook4",
            "cookbook5"
        ],
        positions: [
            ["end", "51 / 101", "1 / 51", ""],
            ["", "1 / 101", "53 / 103", "center"],
            ["", "1 / 101", "105 / 155", "center"],
            ["", "1 / 101", "157 / 207", "center"],
            ["", "1 / 101", "209 / 259", "center"]
        ],
        pdf: "cookbookPDF"
    },
    {
        title: "Landing Page Mockup Redesign And Digital Ad Campaign",
        software: "Illustrator",
        year: "2023",
        thumbnail: "adsMockupRectangle",
        imgs: [
            "adsMockupBanner",
            "adsMockupRectangle",
            "adsMockupSkyscraper",
            "landingPage",
        ],
        positions: [
            ["end", "1 / 81", "36 / 50", ""],
            ["", "42 / 81", "1 / 34", "end"],
            ["", "85 / 101", "1 / 50", "end"],
            ["start", "1 / 101", "56 / 322", ""],
        ],
        pdf: ""
    },
    {
        title: "2023 Calendar",
        software: "InDesign",
        year: "2023",
        thumbnail: "calendar",
        imgs: ["calendar"],
        pdf: "calendarPDF"
    },
    {
        title: "Magazine",
        software: "InDesign",
        year: "2023",
        thumbnail: "magazine1",
        imgs: [
            "magazine1",
            "magazine2"
        ],
        positions: [
            ["", "59 / 101", "1 / 51", "end"],
            ["end", "1 / 56", "18 / 51", ""],
        ],
        pdf: "magazinePDF"
    },
];